import { addYears, getYear } from 'date-fns'
import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { IconButton, Picker } from './styled'

function YearPicker({ date, change }: IYearPickerProps & IYearPickerDispatch) {
  function changeYear(action: number) {
    return function() {
      change(addYears(date, action))
    }
  }

  return (
    <Picker>
      <IconButton onClick={changeYear(-1)} left={true}>
        <FiChevronLeft />
      </IconButton>
      <IconButton onClick={changeYear(1)} right={true}>
        <FiChevronRight />
      </IconButton>
      {getYear(date)}
    </Picker>
  )
}

export default YearPicker

export interface IYearPickerProps {
  date: Date
}

export interface IYearPickerDispatch {
  change?: (date: Date) => void
}
